import { useState } from 'react';
import { StartScreen } from './components/screens/StartScreen.jsx';
import DiceSettlement from './components/game/DiceSettlement.jsx';
import { loadGame, deleteSave, hasSavedGame } from './utils/saveManager.js';
import { AudioProvider } from './audio/AudioContext.jsx';
import { PWAUpdatePrompt } from './pwa/PWAUpdatePrompt.jsx';

export default function App() {
  const [gameMode, setGameMode] = useState('start'); // 'start' | 'playing'
  const [initialState, setInitialState] = useState(null);

  const handleNewGame = () => {
    // Confirm if save exists
    if (hasSavedGame()) {
      if (!window.confirm('Start a new game? This will overwrite your current save.')) {
        return;
      }
    }

    deleteSave();
    setInitialState(null);
    setGameMode('playing');
  };

  const handleLoadGame = () => {
    const savedState = loadGame();

    if (savedState) {
      setInitialState(savedState);
      setGameMode('playing');
    } else {
      alert('Failed to load saved game. Starting new game instead.');
      setInitialState(null);
      setGameMode('playing');
    }
  };

  const handleReturnToMenu = () => {
    setGameMode('start');
    setInitialState(null);
  };

  return (
    <AudioProvider>
      {gameMode === 'start' ? (
        <StartScreen
          onNewGame={handleNewGame}
          onLoadGame={handleLoadGame}
        />
      ) : (
        <DiceSettlement
          initialState={initialState}
          onReturnToMenu={handleReturnToMenu}
        />
      )}
      <PWAUpdatePrompt />
    </AudioProvider>
  );
}
